import SystemQuestionKnowledge from "../../SystemQuestionKnowledge";
import SystemOptionsCard from "../../../cards/SystemOptionsCard";
import {get_nested} from "../../../../services/JsonHandler";
import {useState} from "react";
import FlashCorrectionQuestionQueryText from "../../../texts/courses/flash/FlashCorrectionQuestionQueryText";
import FlashCorrectionContentLayout from "../../../layouts/courses/flash/FlashCorrectionContentLayout";
import FlashCorrectionOptionsLayout from "../../../layouts/courses/flash/FlashCorrectionOptionsLayout";
import NeoFlashQuestionPicture from "../../flashScreen/NeoFlashQuestionPicture";
import NeoFlashZoomedPictureDialog from "../../../dialogs/flashScreen/NeoFlashZoomedPictureDialog";
import {isNullOrUndefined} from "../../../../services/Validator";

export default function FlashCorrectionContent({question, levelA}) {
    // Used in FlashCorrectionScreen

    // PROPERTIES
    // ---- Modal
    const [isPictureModalOpen, setIsPictureModalOpen] = useState(false)
    // ---- Question
    const questionQuery = get_nested(['query'], question, null)
    const questionKnowledge = get_nested(['levelAKnowledge'], levelA, null)
    const questionPictureUrl = get_nested(['questionPicture', 'filePath'], question, null)

    // BUILD
    return (
        <div className={"overflow-auto bg-backgroundLight3 w-full grow flex flex-col items-center"}>
            <FlashCorrectionContentLayout>
                {/** MODAL */}
                <NeoFlashZoomedPictureDialog open={isPictureModalOpen}
                                             handleClose={() => setIsPictureModalOpen(false)}
                                             pictureUrl={questionPictureUrl} />
                {/** CORE */}
                <FlashCorrectionQuestionQueryText query={questionQuery} />
                {!isNullOrUndefined(questionPictureUrl) && (
                    <div className={"mt-[8px] w-full max-w-[1024px] h-[256px] max-h-[256px] flex flex-col justify-center items-center"}>
                        <NeoFlashQuestionPicture pictureUrl={questionPictureUrl}
                                                 openZoom={() => setIsPictureModalOpen(true)} />
                    </div>
                )}
                <SystemQuestionKnowledge knowledge={questionKnowledge} />
                <FlashCorrectionOptionsLayout>
                    <SystemOptionsCard question={question} />
                </FlashCorrectionOptionsLayout>
            </FlashCorrectionContentLayout>
        </div>
    );
}